function initializeTheme(scope = document) {
  scope.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';
    gallery.querySelectorAll('[data-gallery-target]').forEach(link => {
      link.addEventListener('click', event => {
        const target = document.getElementById(link.dataset.galleryTarget);
        if (!target || !gallery.contains(target)) return;
        event.preventDefault();
        gallery.querySelectorAll('[data-gallery-panel]').forEach(panel => { panel.hidden = panel !== target; });
        gallery.querySelectorAll('[data-gallery-target]').forEach(thumb => { thumb.setAttribute('aria-current', String(thumb === link)); });
      });
    });
  });
  scope.querySelectorAll('[data-variant-select]').forEach(select => {
    if (select.dataset.initialized) return;
    select.dataset.initialized = 'true';
    const form = select.closest('form');
    const section = select.closest('.product-details');
    const update = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      section.querySelector('[data-product-price]').textContent = option.dataset.price;
      const available = option.dataset.available === 'true';
      const button = form.querySelector('[data-add-button]');
      button.disabled = !available;
      button.textContent = available ? button.dataset.label : button.dataset.unavailable;
      const url = new URL(location.href); url.searchParams.set('variant',option.value);
      history.replaceState({},'',url);
    };
    select.addEventListener('change',update);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initializeTheme());
else initializeTheme();
document.addEventListener('shopify:section:load',event => initializeTheme(event.target));
document.addEventListener('keydown',event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.site-header details[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); });
});
document.addEventListener('click',event => document.querySelectorAll('.site-header details[open]').forEach(details => {if(!details.contains(event.target)) details.open=false;}));
